import { render, staticRenderFns } from "./ChangeInfoOwnerDrawer.vue?vue&type=template&id=f5c8c000"
import script from "./ChangeInfoOwnerDrawer.vue?vue&type=script&lang=js"
export * from "./ChangeInfoOwnerDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports